import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PDFDocumentProxy, PDFProgressData, PdfViewerModule } from 'ng2-pdf-viewer';
import { GeralService } from 'src/app/shared/services/http';

@Component({
  selector: 'app-leitor-pdf',
  standalone: true,
  imports: [FormsModule, CommonModule, PdfViewerModule],
  templateUrl: './leitor-pdf.component.html',
  styleUrls: ['./leitor-pdf.component.scss'],
})
export class LeitorPdfComponent implements OnChanges {
  @Input({ required: true }) public source: string = '';
  @Input() public titulo: string = '';
  @Output() public fecharLeitorPdf = new EventEmitter();

  public carregando: boolean = true;
  public erroAoCarregar: boolean = false;

  public paginaAtual: number = 1;
  public totalDePaginasDoPdf: number = 0;
  public zoom: number = 1.0;
  public zoomEmPorcentagem = '100';

  constructor(private geralService: GeralService) {}

  ngOnChanges(): void {
    this.zoom = 1.0;
    this.paginaAtual = 1;

    if (this.source && this.source.includes('www.dropbox.com')) {
      this.source = this.source.replace('www.dropbox.com', 'dl.dropboxusercontent.com');
    }
  }

  public pdfCarregado(pdf: PDFDocumentProxy) {
    this.totalDePaginasDoPdf = pdf.numPages;
    this.carregando = false;
  }

  public baixarPdf() {
    const link = ['https', 'http'];
    const contemUmLink = link.some((palavra) => this.source.includes(palavra));

    const tipo = contemUmLink ? 'download' : 'base64';
    this.geralService.abrirArquivo(this.source, tipo);
  }

  public pdfCarregando(progresso: PDFProgressData) {
    if (progresso.loaded === progresso.total) this.carregando = false;
  }

  public mudarValorDoZoom(event: any) {
    this.zoomEmPorcentagem = event.target.value;
    this.converteValorDoZoomParaDecimal();
  }

  public converteValorDoZoomParaDecimal() {
    const valorEmPorcetagem = parseFloat(this.zoomEmPorcentagem.replace('%', ''));
    if (!isNaN(valorEmPorcetagem) && valorEmPorcetagem >= 0) {
      this.zoom = valorEmPorcetagem / 100;
    } else {
      this.zoom = 1;
      this.converteValorDoZoomParaString();
    }
  }

  public converteValorDoZoomParaString() {
    this.zoomEmPorcentagem = `${(this.zoom * 100).toFixed(0)}%`;
  }

  public aumentarZoom() {
    this.zoom = parseFloat((this.zoom + 0.1).toFixed(1));
    this.converteValorDoZoomParaString();
  }

  public dimunirZoom() {
    if (this.zoom === 0) return;
    this.zoom = parseFloat((this.zoom - 0.1).toFixed(1));
    this.converteValorDoZoomParaString();
  }
}
